export var UserStatus;
(function (UserStatus) {
    UserStatus["ACTIVE"] = "active";
    UserStatus["DELETED"] = "deleted";
})(UserStatus || (UserStatus = {}));
export var UserVerificationMethod;
(function (UserVerificationMethod) {
    UserVerificationMethod["PHONE"] = "phone";
    UserVerificationMethod["EMAIL"] = "email";
})(UserVerificationMethod || (UserVerificationMethod = {}));
//# sourceMappingURL=user.js.map